import * as React from "react";
import {
  Edit,
  FormWithRedirect,
  TextInput,
  ImageInput,
  ImageField,
  required,
  ReferenceInput,
  SelectInput,
  Toolbar,
  BooleanInput,
} from "react-admin";
import { Card, CardContent } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";

const OfferEdit = (props) => (
  <Edit {...props}>
    <FormWithRedirect
      {...props}
      redirect="list"
      render={(formProps) => (
        <div>
          <Card>
            <form>
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  Offer Details
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <TextInput
                      label="Offer"
                      source="offerTitle"
                      style={{ width: "20.5em" }}
                      variant="standard"
                      validate={required()}
                    />
                  </Grid>

                  <Grid item xs={5}>
                    <ReferenceInput
                      label="User"
                      source="user.id"
                      reference="User"
                      validate={required()}
                      style={{ width: "20.5em" }}
                      variant="standard"
                      filter={{
                        isMentor: true,
                        profileVerified: true,
                      }}
                    >
                      <SelectInput optionText="name" />
                    </ReferenceInput>
                  </Grid>

                  <Grid item xs={1}></Grid>
                  <Grid item xs={12}>
                    <ImageInput
                      source="offerImage"
                      label="Offer Image"
                      style={{ width: "20.5em" }}
                      accept="image/*"
                    >
                      <ImageField source="src" />
                    </ImageInput>
                  </Grid>
                  <Grid item xs={6}>
                    <BooleanInput source="isApproved" label="Approve" />
                  </Grid>
                  <Grid item xs={6}>
                    <SelectInput
                      source="status"
                      optionText="name"
                      choices={[
                        { id: "Pending", name: "Pending Approval" },
                        { id: "Approved", name: "Approved" },
                      ]}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Toolbar
                record={formProps.record}
                basePath={formProps.basePath}
                undoable={true}
                invalid={formProps.invalid}
                handleSubmit={formProps.handleSubmit}
                saving={formProps.saving}
                resource="Offering"
                redirect="list"
              />
            </form>
          </Card>
        </div>
      )}
    />
  </Edit>
);

export default OfferEdit;
